export const siteLocationPrefix = "/games/developer-store";

// Auth is shared with the onboarding hub: EDS login/logout/callback piggyback on onboarding's
// `/games/publish/auth/*` handlers, whose redirect URI is the one registered on the first-party
// app. EDS owns no auth endpoints of its own (avoids an Azure redirect-URI registration for the POC).
export const onboardingSiteLocationPrefix = "/games/publish";

// Microsoft privacy statement — shown before address (PII) collection, matching the
// onboarding hub's privacyPolicyURL value.
export const privacyStatementUrl = "https://privacy.microsoft.com/privacystatement";
